import { render, staticRenderFns } from "./ConfigSms.vue?vue&type=template&id=c3c46b7a"
import script from "./ConfigSms.vue?vue&type=script&lang=js"
export * from "./ConfigSms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports